// Bepaalt hoe een portfolio-item veilig getoond wordt.
//
// Uitgangspunt: een bedrijf mag nooit van UGC4you af geleid worden om het werk
// van een creator te bekijken. Een uitgaande link naar YouTube/Instagram/TikTok
// haalt de koper uit de flow en zet hem op een pagina waar hij de creator
// rechtstreeks kan benaderen. Alles speelt daarom op het platform zelf af, of
// helemaal niet.
//
//   kind: 'file'    -> eigen upload, speelt inline af in een <video>
//         'youtube' -> YouTube-embed, speelt inline af in een <iframe>
//         'blocked' -> externe link (Instagram/TikTok/overig): alleen thumbnail
//
// Deze logica stond eerder gedupliceerd in CreatorDetailPage, CreatorsPage en
// ProjectProposalsPage, waarbij die laatste twee varianten wél een uitgaande
// <a> renderden. Eén bron van waarheid voorkomt dat het opnieuw uiteenloopt.

const YT_PATROON = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,15})/
const VIDEO_EXT = /\.(mp4|webm|mov|m4v|ogv)(\?|#|$)/i
const EIGEN_UPLOAD = /(\/uploads\/videos\/|cloudinary\.com)/i

export const getPortfolioEmbed = (item) => {
  const url = item?.videoUrl || ''
  const poster = item?.thumbnailUrl || ''

  const yt = url.match(YT_PATROON)
  if (yt) {
    // nocookie-domein + modestbranding/rel=0: zo min mogelijk YouTube-chrome.
    // De speler toont bovenin nog steeds een titelbalk die naar YouTube linkt;
    // die wordt in de UI afgedekt met een overlay (zie YouTubeEmbed hieronder).
    const params = 'modestbranding=1&rel=0&playsinline=1&iv_load_policy=3'
    return {
      kind: 'youtube',
      src: `https://www.youtube-nocookie.com/embed/${yt[1]}?${params}`,
      poster: poster || `https://img.youtube.com/vi/${yt[1]}/hqdefault.jpg`
    }
  }

  if (VIDEO_EXT.test(url) || EIGEN_UPLOAD.test(url)) {
    return { kind: 'file', src: url, poster }
  }

  return { kind: 'blocked', poster }
}

export default getPortfolioEmbed
